<!-- =========================================================================================
	File Name: TheNavbar.vue
	Description: Navbar component
	Component Name: TheNavbar
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="relative">
        <div>
            <vs-navbar class="vx-navbar navbar-custom" style="background: rgb(247,247,247)" :class="classObj">
                <!-- SM - OPEN SIDEBAR BUTTON -->
                <feather-icon class="sm:inline-flex xl:hidden cursor-pointer mr-1" icon="MenuIcon"
                              @click.stop="showSidebar"></feather-icon>

                <template v-if="breakpoint != 'md'">
                    <!-- STARRED PAGES - FIRST 10 -->
                    <ul class="vx-navbar__starred-pages">
                        <draggable v-model="starredPagesLimited" :group="{name: 'pinList'}" class="flex cursor-move">
                            <li class="starred-page" v-for="page in starredPagesLimited" :key="page.url">
                                <vx-tooltip :text="page.label" position="bottom" delay=".3s">
                                    <feather-icon svgClasses="h-6 w-6" class="p-2 cursor-pointer" :icon="page.labelIcon"
                                                  @click="$router.push(page.url)"></feather-icon>
                                </vx-tooltip>
                            </li>
                        </draggable>
                    </ul>

                    <!-- STARRED PAGES MORE -->
                    <div class="vx-navbar__starred-pages--more-dropdown" v-if="starredPagesMore.length">
                        <vs-dropdown vs-custom-content vs-trigger-click>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"
                                          class="cursor-pointer p-2"></feather-icon>
                            <vs-dropdown-menu>
                                <ul class="vx-navbar__starred-pages-more--list">
                                    <draggable v-model="starredPagesMore" :group="{name: 'pinList'}"
                                               class="cursor-move">
                                        <li class="starred-page--more flex items-center cursor-pointer"
                                            v-for="page in starredPagesMore" :key="page.url"
                                            @click="$router.push(page.url)">
                                            <feather-icon svgClasses="h-5 w-5" class="ml-2 mr-1"
                                                          :icon="page.labelIcon"></feather-icon>
                                            <span class="px-2 pt-2 pb-1">{{ page.label }}</span>
                                        </li>
                                    </draggable>
                                </ul>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>

                    <div class="bookmark-container">
                        <!-- <feather-icon icon="StarIcon" :svgClasses="['stoke-current text-warning', {'text-white': navbarColor != '#fff'}]" class="cursor-pointer p-2" @click.stop="showBookmarkPagesDropdown = !showBookmarkPagesDropdown" /> -->
                        <div v-click-outside="outside" class="absolute bookmark-list w-1/3 xl:w-1/4 mt-4"
                             v-if="showBookmarkPagesDropdown">
                            <vx-auto-suggest :autoFocus="true" :data="navbarSearchAndPinList" @selected="selected"
                                             @actionClicked="actionClicked" inputClassses="w-full" show-action
                                             show-pinned background-overlay></vx-auto-suggest>
                        </div>
                    </div>
                </template>

                <vs-spacer></vs-spacer>

                <div class="nav-logo">
                    <img :src="require('@/assets/images/logo/timeless.png')" alt="" width="88">
                </div>
                <vs-spacer></vs-spacer>

                <!-- NOTIFICATIONS -->
                <vs-row style="width: 50px;margin-top: 10px" vs-type="flex" vs-jusitfy="center" class="cursor-pointer">
                    <vs-col vs-w="12">
                        <feather-icon icon="BellIcon" :badge="flag" @click="$router.push('/notification')"></feather-icon>
                    </vs-col>
                </vs-row>

                <vs-row style="width: 50px;margin-top: 10px" vs-type="flex" vs-jusitfy="center" class="cursor-pointer" v-if="currentUser.role == 'user'">
                    <vs-col vs-w="12">
                        <feather-icon icon="MessageCircleIcon" @click="$router.push('/contact')"></feather-icon>
                    </vs-col>
                </vs-row>

                <!-- TODO:USER META -->
                <div class="the-navbar__user-meta flex items-center sm:ml-5 ml-2">
                    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                        <vs-row vs-type="flex" vs-jusitfy="center">
                            <vs-col vs-w="12">
                                <img :src="currentUser.profilePic ? currentUser.profilePic.fileUrl : require('../../assets/images/pages/image.png')" alt=""
                                     width="30" height="30" class="rounded-full cursor-pointer">
                                <span class="nav-font" style="margin-left: 10px" v-if="!isMobile()">{{currentUser.username}}</span>
                            </vs-col>
                        </vs-row>
                        <vs-dropdown-menu>
                            <ul style="min-width: 9rem">
                                <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                                    @click="$router.push('/profile')">
                                    <feather-icon icon="UserIcon" svgClasses="w-4 h-4"></feather-icon>
                                    <span class="ml-2">{{$t('message.profile')}}</span></li>
                                <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                                    @click="onLogOut()">
                                    <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4"></feather-icon>
                                    <span class="ml-2">{{$t('message.logout')}}</span></li>
                            </ul>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <div class="the-navbar__user-meta flex items-center sm:ml-5 ml-2">
                    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                        <vs-row vs-type="flex" vs-jusitfy="center">
                            <vs-col vs-w="12">
                                <span class="nav-font" style="margin-right: 10px">{{lang == 'zh' ? '繁體中文' : (lang == 'zh_cn' ? '简体中文' : 'English')}}</span>
                                <vs-icon class="" icon="expand_more" color="rgb(37, 105, 193)"></vs-icon>
                            </vs-col>
                        </vs-row>
                        <vs-dropdown-menu>
                            <ul style="min-width: 9rem">
                                <li v-for="item in langOpt" v-if="item.value != lang" class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="changeLang(item.value)">
                                    <span class="ml-2">{{item.text}}</span></li>
                            </ul>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

            </vs-navbar>
        </div>
    </div>
</template>

<script>
    import VxAutoSuggest from '@/components/vx-auto-suggest/VxAutoSuggest.vue';
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import draggable from 'vuedraggable'
    import {
        mapGetters,
        mapActions
    } from "vuex";

    export default {
        name: "the-navbar",
        props: {
            navbarColor: {
                type: String,
                default: "#fff",
            },
        },
        data() {
            return {
                navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
                searchQuery: '',
                showFullSearch: false,
                settings: { // perfectscrollbar settings
                    maxScrollbarLength: 60,
                    wheelSpeed: .60,
                },
                autoFocusSearch: false,
                showBookmarkPagesDropdown: false,

                langOpt:[
                    {
                        text:'English',
                        value:'en'
                    },
                    {
                        text:'繁體中文',
                        value:'zh'
                    },
                    {
                        text:'简体中文',
                        value:'zh_cn'
                    }
                ],
                lang:'',
                timer:null


            }
        },
        created() {
            this.lang = this.$cookies.get('lang')
            this.$store.dispatch('getFlag',{token:this.$cookies.get('token')})

        },
        beforeMount() {
            if (this.timer) {
                clearInterval(this.timer)
            } else if (this.$cookies.get('token') && !this.timer) {
                this.timer = setInterval(() => {
                    this.$store.dispatch('getFlag',{token:this.$cookies.get('token')})
                }, 300000)

            }
        },
        watch: {
            '$route'() {
                if (this.showBookmarkPagesDropdown) this.showBookmarkPagesDropdown = false
            }
        },
        computed: {
            ...mapGetters(["currentUser","flag"]),
            // HELPER
            sidebarWidth() {
                return this.$store.state.sidebarWidth;
            },
            breakpoint() {
                return this.$store.state.breakpoint;
            },

            // NAVBAR STYLE
            classObj() {
                if (this.sidebarWidth == "default") return "navbar-default"
                else if (this.sidebarWidth == "reduced") return "navbar-reduced"
                else if (this.sidebarWidth) return "navbar-full"
            },

            // BOOKMARK & SEARCH
            data() {
                return this.$store.state.navbarSearchAndPinList;
            },
            starredPages() {
                return this.$store.state.starredPages;
            },
            starredPagesLimited: {
                get() {
                    return this.starredPages.slice(0, 10);
                },
                set(list) {
                    this.$store.dispatch('arrangeStarredPagesLimited', list);
                }
            },
            starredPagesMore: {
                get() {
                    return this.starredPages.slice(10);
                },
                set(list) {
                    this.$store.dispatch('arrangeStarredPagesMore', list);
                }
            },

            // CART DROPDOWN
            cartItems() {
                return this.$store.state.eCommerce.cartItems.slice().reverse();
            },

            // PROFILE
            activeUserInfo() {
                return this.$store.state.AppActiveUser;
            },
        },
        methods: {
            changeLang(lang){
                this.$cookies.set('lang',lang)
                location.reload()
            },
            onLogOut() {
                this.$cookies.set('login', false);
                this.$cookies.set('user', null);
                this.$cookies.set('role', null);
                this.$cookies.set('token', null);
                this.$router.push('/pages/login')
            },
            showSidebar() {
                this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', true);
            },
            selected(item) {
                this.$router.push(item.url)
                this.showFullSearch = false;
            },
            actionClicked(item) {
                // e.stopPropogation();
                this.$store.dispatch('updateStarredPage', {index: item.index, val: !item.highlightAction});
            },
            showNavbarSearch() {
                this.showFullSearch = true;
            },
            showSearchbar() {
                this.showFullSearch = true;
            },
            elapsedTime(startTime) {
                let x = new Date(startTime);
                let now = new Date();
                var timeDiff = now - x;
                timeDiff /= 1000;

                var seconds = Math.round(timeDiff);
                timeDiff = Math.floor(timeDiff / 60);

                var minutes = Math.round(timeDiff % 60);
                timeDiff = Math.floor(timeDiff / 60);

                var hours = Math.round(timeDiff % 24);
                timeDiff = Math.floor(timeDiff / 24);

                var days = Math.round(timeDiff % 365);
                timeDiff = Math.floor(timeDiff / 365);

                var years = timeDiff;

                if (years > 0) {
                    return years + (years > 1 ? ' Years ' : ' Year ') + 'ago';
                } else if (days > 0) {
                    return days + (days > 1 ? ' Days ' : ' Day ') + 'ago';
                } else if (hours > 0) {
                    return hours + (hours > 1 ? ' Hrs ' : ' Hour ') + 'ago';
                } else if (minutes > 0) {
                    return minutes + (minutes > 1 ? ' Mins ' : ' Min ') + 'ago';
                } else if (seconds > 0) {
                    return seconds + (seconds > 1 ? `${seconds} sec ago` : 'just now');
                }

                return 'Just Now'
            },
            outside: function () {
                this.showBookmarkPagesDropdown = false
            },
        },
        directives: {
            'click-outside': {
                bind: function (el, binding) {
                    const bubble = binding.modifiers.bubble
                    const handler = (e) => {
                        if (bubble || (!el.contains(e.target) && el !== e.target)) {
                            binding.value(e)
                        }
                    }
                    el.__vueClickOutside__ = handler
                    document.addEventListener('click', handler)
                },

                unbind: function (el) {
                    document.removeEventListener('click', el.__vueClickOutside__)
                    el.__vueClickOutside__ = null

                }
            }
        },
        components: {
            VxAutoSuggest,
            VuePerfectScrollbar,
            draggable
        },
    }
</script>

<style>
    .nav-font{
        color: rgb(37, 105, 193);
    }
    .vs-navbar{
        border-bottom: 1px solid whitesmoke;
    }
    .vs-navbar.vx-navbar{
        padding: 0 1rem;
    }

    .nav-logo{
        margin-left:250px;
    }

    @media screen and (max-width: 650px){
        .nav-logo{
            display: none;
        }
    }
</style>
